import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { System } from '../../shared-components/System';
import { YearService } from '../../shared-components/year/year.service';
import { AssignedReports, MyReportsFolder } from './reporting-framework.model';

@Injectable()
export class ReportingFrameworkService {

  constructor(
    private yearService: YearService,
    private http: HttpClient
  ) { }

  getMyReportsFolders(): Observable<MyReportsFolder[]> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID;
    return this.http.get<MyReportsFolder[]>(System.apiURL.Classroom + 'GetMyReportsFolders' + queryString);
  }

  saveMyReportFolder(myReportFolder: MyReportsFolder): Observable<boolean> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID;
    return this.http.post<boolean>(System.apiURL.Classroom + 'SaveMyReportFolder' + queryString, myReportFolder);
  }

  saveReportsInFolder(folderId: Number, reportIds: Number[]): Observable<boolean> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID +
      '&folderId=' + folderId;
    return this.http.post<boolean>(System.apiURL.Classroom + 'SaveReportsInFolder' + queryString, reportIds);
  }

  deleteMyReportFolder(folderId: Number): Observable<boolean> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID +
      '&folderId=' + folderId;
    return this.http.get<boolean>(System.apiURL.Classroom + 'DeleteMyReportFolder' + queryString);
  }

  deleteReportInFolder(folderId: Number, reportId: Number): Observable<boolean> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID +
      '&folderId=' + folderId + '&reportId=' + reportId;
    return this.http.get<boolean>(System.apiURL.Classroom + 'DeleteReportInFolder' + queryString);
  }

  addReportInFolders(reportId: Number, folderIds: Number[]): Observable<boolean> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID +
      '&reportId=' + reportId;
    return this.http.post<boolean>(System.apiURL.Classroom + 'AddReportInFolders' + queryString, folderIds);
  }

  getAssignedReportFolders(callByPage = true): Observable<AssignedReports[]> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID +
      '&callByPage=' + callByPage;
    return this.http.get<AssignedReports[]>(System.apiURL.Classroom + 'GetAssignedReportFolders' + queryString);
  }

  saveAssignedReportFolder(assignedReportFolder: AssignedReports): Observable<boolean> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID;
    return this.http.post<boolean>(System.apiURL.Classroom + 'SaveAssignedReportFolder' + queryString, assignedReportFolder);
  }

  deleteAssignReportFolder(folderId: Number): Observable<boolean> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID +
      '&folderId=' + folderId;
    return this.http.get<boolean>(System.apiURL.Classroom + 'DeleteAssignReportFolder' + queryString);
  }

  deleteAssignReportInFolder(folderId: Number, reportId: Number): Observable<boolean> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID +
      '&folderId=' + folderId + '&reportId=' + reportId;
    return this.http.get<boolean>(System.apiURL.Classroom + 'DeleteAssignReportInFolder' + queryString);
  }

  saveAssignedReportsInFolder(folderId: Number, reportIds: Number[]): Observable<boolean> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID +
      '&folderId=' + folderId;
    return this.http.post<boolean>(System.apiURL.Classroom + 'SaveAssignedReportsInFolder' + queryString, reportIds);
  }

  savePermissionGroupsInFolder(folderId: Number, permissionGroupIds: Number[]): Observable<boolean> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID +
      '&folderId=' + folderId;
    return this.http.post<boolean>(System.apiURL.Classroom + 'SavePermissionGroupsInFolder' + queryString, permissionGroupIds);
  }

  checkDefaultLandingPage(): Observable<boolean> {
    const queryString = '?yearId=' + this.yearService.defaultYear.Id +
      '&siteId=' + this.yearService.defaultYear.SchoolID;
    return this.http.get<boolean>(System.apiURL.Classroom + 'CheckDefaultLandingPage' + queryString);
  }
}
